import React from 'react';
import { Navigation, Heart, Leaf, Sparkles, BookOpen } from 'lucide-react';
export function MethodSection() {
  // GPS Interior is now the center, with 4 other pillars around it
  const centerPillar = {
    title: 'GPS INTERIOR',
    text: 'Înveți să te observi fără critică. Oprești pilotul automat și instalezi prezența activă, claritate în emoții și decizii conștiente în fiecare zi.',
    icon: Navigation
  };
  const surroundingPillars = [{
    title: 'RESET EMOȚIONAL',
    text: 'Descoperi tiparele care te țin pe loc, înțelegi de unde vin și decizi să schimbi perspectiva, într-un spațiu sigur, ghidat și fără judecată.',
    icon: Heart,
    position: 'top'
  }, {
    title: 'TERAPII NATURALE',
    text: 'Primești intervenții psiho-medicale personalizate: uleiuri, plante, acupunctură, homeopatie, pentru susținerea echilibrului fizic și emoțional.',
    icon: Leaf,
    position: 'right'
  }, {
    title: 'RECONECTARE',
    text: 'Te întorci la corpul, bucuria și ritualurile tale zilnice. Reactivezi energia și resetezi sistemul nervos prin practici simple și plăceri reale.',
    icon: Sparkles,
    position: 'bottom'
  }, {
    title: 'JURNAL PSIHO-MEDICAL',
    text: 'Instrumentul tău zilnic de autocunoaștere, procesare și ancorare. Întrebări despre emoții, corp, nevoi și alegeri, fără suprasolicitare.',
    icon: BookOpen,
    position: 'left'
  }];
  return <section className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-110" data-mp="1cag4cr0zrpht">
      <div className="max-w-7xl mx-auto" data-id="element-111" data-mp="1hbvpsk72zy0q">
        <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-112" data-mp="1h8hkp4719apl">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-dark mb-6" data-id="element-113" data-mp="12ev34v3qyt94">
            PsihoMedicina: GPS-ul tău Interior
          </h2>
          <div className="w-16 h-0.5 bg-primary mx-auto mb-6" data-id="element-114" data-mp="2wrkylh9rkaim"></div>
          <p className="text-lg text-body leading-relaxed" data-id="element-115" data-mp="2wsdx5uykjtpo">
            Procesul prin care înveți să îți citești corpul, să îți înțelegi
            emoțiile și să alegi conștient ce îți face bine, printr-un sistem
            integrat cu 5 elemente care lucrează împreună.
          </p>
        </div>

        {/* GPS Circle Layout - Desktop */}
        <div className="hidden lg:block relative mx-auto" style={{
        height: '900px',
        maxWidth: '1000px'
      }} data-id="element-116" data-mp="2qaswz28ajleh">
          {/* Center - GPS INTERIOR */}
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-20" data-id="element-117" data-mp="3j09lhossii5f">
            <div className="bg-gradient-to-br from-primary to-medium rounded-2xl p-8 shadow-2xl text-white w-72 border-4 border-white" data-id="element-118" data-mp="3e0nbrpc67k1d">
              <div className="flex flex-col items-center text-center" data-id="element-119" data-mp="398dpcja9l23u">
                <div className="w-16 h-16 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center mb-4" data-id="element-120" data-mp="357jwdbhysx43">
                  <Navigation size={32} data-id="element-121" data-mp="5meomwsf3lgl" />
                </div>
                <h3 className="text-2xl font-bold mb-3" data-id="element-122" data-mp="u53rv65tbl6">
                  {centerPillar.title}
                </h3>
                <p className="text-sm leading-relaxed text-white/90" data-id="element-123" data-mp="1jig8bq5m8da0">
                  {centerPillar.text}
                </p>
              </div>
            </div>
          </div>

          {/* Top - Reset Emoțional */}
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-64 z-10" data-id="element-124" data-mp="1sgi9q6t9h7xt">
            <div className="bg-soft rounded-2xl p-6 shadow-lg text-center" data-id="element-125" data-mp="1xih812a59enw">
              <div className="w-12 h-12 rounded-full bg-primary text-white flex items-center justify-center mx-auto mb-3" data-id="element-126" data-mp="22ey1mc044l8d">
                <Heart size={24} data-id="element-127" data-mp="27d99ih6uklny" />
              </div>
              <h3 className="text-lg font-bold text-dark mb-2" data-id="element-128" data-mp="2c5ajfwgjm0at">
                {surroundingPillars[0].title}
              </h3>
              <p className="text-sm text-body leading-relaxed" data-id="element-129" data-mp="2g647cptzjf3p">
                {surroundingPillars[0].text}
              </p>
            </div>
          </div>

          {/* Right - Terapii Naturale */}
          <div className="absolute top-1/2 right-8 transform -translate-y-1/2 w-64 z-10" data-id="element-130" data-mp="2q63dkg2xmtde">
            <div className="bg-soft rounded-2xl p-6 shadow-lg" data-id="element-131" data-mp="2chjtiaab8dxj">
              <div className="w-12 h-12 rounded-full bg-primary text-white flex items-center justify-center mx-auto mb-3" data-id="element-132" data-mp="27k1kyl07g0q2">
                <Leaf size={24} data-id="element-133" data-mp="2m7mlq89lxnut" />
              </div>
              <h3 className="text-lg font-bold text-dark mb-2 text-center" data-id="element-134" data-mp="2mailm250mmlw">
                {surroundingPillars[1].title}
              </h3>
              <p className="text-sm text-body leading-relaxed text-center" data-id="element-135" data-mp="1tl1tl5lb57q7">
                {surroundingPillars[1].text}
              </p>
            </div>
          </div>

          {/* Bottom - Reconectare */}
          <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-64 z-10" data-id="element-136" data-mp="23iy3ju2idwmq">
            <div className="bg-soft rounded-2xl p-6 shadow-lg text-center" data-id="element-137" data-mp="1yi1xpaylk0eo">
              <div className="w-12 h-12 rounded-full bg-primary text-white flex items-center justify-center mx-auto mb-3" data-id="element-138" data-mp="3ewtsfuj7tjr5">
                <Sparkles size={24} data-id="element-139" data-mp="39x77t012518b" />
              </div>
              <h3 className="text-lg font-bold text-dark mb-2" data-id="element-140" data-mp="3hhrimmfjdvlb">
                {surroundingPillars[2].title}
              </h3>
              <p className="text-sm text-body leading-relaxed" data-id="element-141" data-mp="3mh4dnugka8yz">
                {surroundingPillars[2].text}
              </p>
            </div>
          </div>

          {/* Left - Jurnal Psiho-Medical */}
          <div className="absolute top-1/2 left-8 transform -translate-y-1/2 w-64 z-10" data-id="element-142" data-mp="3cjpxlvyjvm77">
            <div className="bg-soft rounded-2xl p-6 shadow-lg" data-id="element-143" data-mp="42lg1p25rh2q">
              <div className="w-12 h-12 rounded-full bg-primary text-white flex items-center justify-center mx-auto mb-3" data-id="element-144" data-mp="91ycn1iu02ii">
                <BookOpen size={24} data-id="element-145" data-mp="3rgh22jn2zo3o" />
              </div>
              <h3 className="text-lg font-bold text-dark mb-2 text-center" data-id="element-146" data-mp="3rdusyfkjl0jc">
                {surroundingPillars[3].title}
              </h3>
              <p className="text-sm text-body leading-relaxed text-center" data-id="element-147" data-mp="n17fz0lxv252">
                {surroundingPillars[3].text}
              </p>
            </div>
          </div>

          {/* Connecting lines */}
          <svg className="absolute inset-0 w-full h-full pointer-events-none" style={{
          zIndex: 1
        }} data-id="element-148" data-mp="11opqifm6mqze">
            <line x1="50%" y1="16%" x2="50%" y2="38%" stroke="#9B59A0" strokeWidth="2" strokeDasharray="5,5" opacity="0.4" data-id="element-149" data-mp="xkzz7ie4hvao" />
            <line x1="70%" y1="50%" x2="62%" y2="50%" stroke="#9B59A0" strokeWidth="2" strokeDasharray="5,5" opacity="0.4" data-id="element-150" data-mp="iqlos68mju7m" />
            <line x1="50%" y1="84%" x2="50%" y2="62%" stroke="#9B59A0" strokeWidth="2" strokeDasharray="5,5" opacity="0.4" data-id="element-151" data-mp="9uw2zw39kxtp" />
            <line x1="30%" y1="50%" x2="38%" y2="50%" stroke="#9B59A0" strokeWidth="2" strokeDasharray="5,5" opacity="0.4" data-id="element-152" data-mp="3r6f086o3mfht" />
          </svg>
        </div>

        {/* Mobile Layout - Stack */}
        <div className="lg:hidden space-y-6" data-id="element-153" data-mp="3r05vvgm52o8m">
          {/* Center GPS Interior Mobile */}
          <div className="bg-gradient-to-br from-primary to-medium rounded-2xl p-8 shadow-2xl text-white border-4 border-white" data-id="element-154" data-mp="3vxee1h7aes9v">
            <div className="flex flex-col items-center text-center" data-id="element-155" data-mp="2y94ct4fbs8jt">
              <div className="w-16 h-16 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center mb-4" data-id="element-156" data-mp="33ajy8xlf0h2q">
                <Navigation size={32} data-id="element-157" data-mp="38721tu50e9dh" />
              </div>
              <h3 className="text-2xl font-bold mb-3" data-id="element-158" data-mp="3d0wqzd3dvgjy">{centerPillar.title}</h3>
              <p className="text-sm leading-relaxed text-white/90" data-id="element-159" data-mp="2fkzggi0zzpv1">
                {centerPillar.text}
              </p>
            </div>
          </div>

          {surroundingPillars.map((pillar, index) => {
          const Icon = pillar.icon;
          return <div key={index} className="bg-soft rounded-2xl p-6 shadow-lg" data-id="element-160" data-mp="2mfz1axs9p0y" data-mpi={index}>
                <div className="flex items-center space-x-4 mb-4" data-id="element-161" data-mp="3uq8lmnbqhjh3">
                  <div className="w-12 h-12 rounded-full bg-primary text-white flex items-center justify-center shrink-0" data-id="element-162" data-mp="cju3ec6fmncw">
                    <Icon size={24} data-id="element-163" data-mp="7iejinfzqmw3" />
                  </div>
                  <h3 className="text-lg font-bold text-dark" data-id="element-164" data-mp="liparrl7q3hs">
                    {pillar.title}
                  </h3>
                </div>
                <p className="text-body leading-relaxed" data-id="element-165" data-mp="hhncpe317xhe">{pillar.text}</p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}